// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3Xn1z","footer":"ChangeClinic_footer__23Htq"};